import Modal from '@mui/material/Modal';
import clsx from 'clsx';
import React from 'react';

import TheInformationLogo from 'images/the-information-logo.svg';

const TIModal = (props) => {
  const {
    children,
    isFullScreen = false,
    isOpen,
    onClose,
    parentClass,
    withLogo = false,
    disableScrollLock,
    customHeader = false,
    ...newProps
  } = props;
  return (
    <Modal open={isOpen} onClose={onClose} disableScrollLock={disableScrollLock} {...newProps}>
      <div
        className={clsx(
          'TIModal',
          'tw-absolute top-1/2 left-1/2 -translate-1/2 z-1000 rounded-2 max-h-full',
          parentClass,
          {
            'h-screen max-w-full xs:h-auto': isFullScreen,
            'h-auto px-16 max-w-full': !isFullScreen,
          }
        )}
      >
        <div
          className={clsx('modal-container bg-white', {
            'justify-start h-full xs:justify-center xs:h-auto': isFullScreen,
            'justify-center h-auto': !isFullScreen,
          })}
        >
          {!customHeader ? (
            <>
              <button className="close-button" onClick={onClose}></button>
              <div className="wrapper">
                {withLogo && (
                  <div className="logo-header">
                    <img src={TheInformationLogo} width={225} />
                  </div>
                )}
                {children}
              </div>
            </>
          ) : (
            <>{children}</>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TIModal;
